<div style="white-space:nowrap;">
  <span (click)="remove()" tooltip="{{'GENERIC_REMOVE' | translate:locale.language}}"> <i class="fa fa-trash-alt"></i></span>
  <span *ngIf="config.presentation === 'detail'" tooltip="{{'ORDER_NOT_ALLOWED_TEXT'|translate:locale.language}}"> <i class="fad fa-lock-alt"></i></span>
</div>
